module.exports = __webpack_public_path__ + "img/selected2-min.4e13c4a9.png";